import '../Css/Adresses.css';
import Informations from './Informations';


export default function LuneDeMiel() {

    // {
    //     "id":4,
    //     "img": "./Images/Icons/honeymoon-icon.png",
    //     "title": "Lune de miel", 
    //     "hour":"Cagnotte pour notre lune de miel",
    //     "maps": "https://www.millemercismariage.com/sylvainbenedicte/liste.html",
    //     "location": "Cliquez ici pour participer",
    //     "description": "Si vous désirez participer à notre projet de lune de miel, une cagnotte est à votre disposition. Ce sera pour nous une manière de prolonger encore un peu la magie de cette journée."
    // }
  return (
    <div className={'adresse-tile reversed'}>
        <img className='adresse-icon' src='./Images/Icons/honeymoon-icon.png' alt='Lune de miel'></img>
        <div className='tile-content'>
            <div className='tile-title'>Cadeau de mariage</div>
            <div className='horaire'>Francs et euros ne pouvant se mêler comme l'huile et l'eau, si vous souhaitez participer à notre lune de miel</div>
            <div className='nom'><div className='cagnotte-nom'>Les Euros : Bénédicte Rambaud</div><div className='separateur'> - </div><div>FR76 1751 5006 0004 0555 5433 717</div></div>
            <div className='nom'><div className='cagnotte-nom'>Les Francs: Sylvain Rey</div><div className='separateur'> - </div><div></div>CH29 0078 8000 0505 1964 8</div>
            <div className='nom'>L'amour franco-suisse lui, en revanche, se marie très bien ensemble 💛🌻</div>
        </div>
    </div>
  );
}